import { useEffect, useState } from "react";
import { Eye, EyeOff, Trash2 } from "lucide-react";
import { api, slDateTime, fmtBytes } from "@/lib/api";

export function GuestbookPanel({ wedding }) {
  const [items, setItems] = useState([]);
  const load = () => api.get(`/manage/weddings/${wedding.id}/guestbook`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [wedding.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const hide = async (g) => { await api.patch(`/manage/weddings/${wedding.id}/guestbook/${g.id}`, { hidden: !g.hidden }); load(); };
  const del = async (g) => { if (window.confirm("Izbrisati sporočilo?")) { await api.delete(`/manage/weddings/${wedding.id}/guestbook/${g.id}`); load(); } };
  if (!items.length) return <p className="text-center py-16 text-[#6C6560]" data-testid="manage-guestbook-empty">V knjigi gostov še ni sporočil.</p>;
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="manage-guestbook">
      {items.map((g) => (
        <div key={g.id} className={`card-lux p-5 space-y-3 ${g.hidden ? "opacity-50" : ""}`} data-testid="manage-guestbook-entry">
          <p className="font-display text-lg italic">“{g.message}”</p>
          <div className="flex items-center justify-between">
            <div><p className="text-sm font-medium">{g.name}</p><p className="text-xs text-[#968E87]">{slDateTime(g.created_at)}</p></div>
            <div className="flex gap-1">
              <button onClick={() => hide(g)} className="p-2 rounded-full hover:bg-[#EADBCE]" data-testid="manage-guestbook-hide" aria-label="Skrij">{g.hidden ? <EyeOff size={16} /> : <Eye size={16} />}</button>
              <button onClick={() => del(g)} className="p-2 rounded-full hover:bg-[#EADBCE]" data-testid="manage-guestbook-delete" aria-label="Izbriši"><Trash2 size={16} /></button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function GuestsPanel({ wedding }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/manage/weddings/${wedding.id}/guests`).then((r) => setRows(r.data)); }, [wedding.id]);
  if (!rows.length) return <p className="text-center py-16 text-[#6C6560]">Gostje še niso naložili spominov.</p>;
  return (
    <div className="card-lux overflow-x-auto" data-testid="manage-guests">
      <table className="w-full text-sm">
        <thead className="text-left text-[#6C6560] border-b border-[#EADBCE]"><tr><th className="p-4 font-medium">Gost</th><th className="p-4 font-medium">Fotografije</th><th className="p-4 font-medium">Videi</th><th className="p-4 font-medium">Velikost</th><th className="p-4 font-medium">Zadnje nalaganje</th></tr></thead>
        <tbody>
          {rows.map((r) => <tr key={r.name} className="border-b border-[#EADBCE]/50 last:border-0" data-testid="manage-guest-row"><td className="p-4 font-medium">{r.name}</td><td className="p-4">{r.photos}</td><td className="p-4">{r.videos}</td><td className="p-4">{fmtBytes(r.size)}</td><td className="p-4 text-[#6C6560]">{slDateTime(r.last)}</td></tr>)}
        </tbody>
      </table>
    </div>
  );
}
